import PropTypes from 'prop-types';
import React from 'react';

function formatTime(duration) {
  return duration.substring(0, duration.lastIndexOf(':'));
}

class EventMapMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showInfo: props.selected };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selected !== nextProps.selected) {
      this.setState({ showInfo: nextProps.selected });
    }
  }
  onMouseEnter = () => {
    this.setState({ showInfo: true });
  }

  onMouseLeave = () => {
    this.setState({ showInfo: false });
  }
  onClick = () => {
    this.props.onSelect(this.props.event.id);
  }

  render() {

    const style = { color: 'black' };
    if (this.props.selected) {
      style.color = 'red';
    }

    let icon = (
      <span className="fa-stack fa-lg" style={style}>
        <i className="fa fa-square fa-stack-2x" />
        <i className="fa fa-stack-1x fa-map-marker fa-inverse" />
      </span>
    );
    let name = 'unknown';
    if (this.props.event) {
      name = this.props.event.name;

      icon = (
        <span className="fa-stack fa-lg" style={style}>
          <i className="fa fa-square fa-stack-2x" />
          <i className="fa fa-stack-1x fa-building fa-inverse" />
        </span>);
    } else {
      name = this.props.name;
    }

    return (
      <div>
        <div
          style={{
            color: '#F00',
            width: 200,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onClick={this.onClick}
        >
          {icon} {name}
        </div>
        { this.state.showInfo &&
          <div
            style={{
              backgroundColor: '#3d4461',
              border: '1px solid #777',
              color: '#FFF',
              width: 160,
              height: 120,
              padding: 10,
              position: 'relative',
              zIndex: 9999,
            }}
          >
            <h5 style={{ margin: 0 }}>{name}</h5>
            <p style={{ margin: 0 }}>{this.props.event.place.city}, {this.props.event.place.state}</p>
            { this.props.nextEvent && (
              <p><strong>Next stop:</strong><br />
              {this.props.nextEvent.name}<br />
              Driving time: {formatTime(this.props.event.duration_to_next)}</p>
            )}
          </div>
        }
      </div>
    );
  }
}

EventMapMarker.propTypes = {
  event: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default EventMapMarker;



// WEBPACK FOOTER //
// src/routes/tours/components/EventMapMarker.js